/**
 * Smooth-scrolls to an element tagged `data-copilot-target="<target>"` and
 * pulses it with a brand ring. Retries briefly so it works even when the
 * target lives on a page the Copilot just navigated to (which mounts async).
 */
export function spotlight(target: string): void {
  let attempts = 0;

  const tryRun = () => {
    const el = document.querySelector<HTMLElement>(`[data-copilot-target="${target}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('copilot-spotlight');
      window.setTimeout(() => el.classList.remove('copilot-spotlight'), 2600);
      return;
    }
    if (attempts++ < 25) window.setTimeout(tryRun, 100);
  };

  window.setTimeout(tryRun, 300);
}
